import React, { useState, useEffect } from 'react';
import apinode from '../../services/apinode';
import {
    Modal,
    Table,
    Spinner,
    Alert,
    Button
} from 'react-bootstrap';

const ModalProduct = ({ order, modalOpen, handleClose }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Função para buscar produtos do pedido na API usando Axios
    const fetchProducts = async (orderId) => {
        setLoading(true);
        setError(null);
        try {
            const response = await apinode.get(`/orderdetails/${orderId}/${localStorage.idconta}`);
            setProducts(response.data.itempedido); // Supondo que a resposta tenha os dados do produto
        } catch (error) {
            setError('Erro ao buscar itens do pedido');
        } finally {
            setLoading(false);
        }
    };

    // UseEffect para buscar produtos ao abrir o modal
    useEffect(() => {
        if (modalOpen) {
            fetchProducts(order.PEDIDO); // Chame a função com o ID do pedido
        }
    }, [modalOpen, order.PEDIDO]);

    return (
        <Modal 
            show={modalOpen} 
            onHide={handleClose} 
            dialogClassName="custom-modalzpl"
            aria-labelledby="modal-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="modal-title">Itens do Pedido: {order.PEDIDO}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Exibir mensagem de carregamento ou erro */}
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" />
                    </div>
                ) : error ? (
                    <Alert variant="danger">{error}</Alert>
                ) : (
                    <Table  striped hover>
                        <thead>
                            <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <th>Sku</th>
                                <th>Produto</th>
                                <th>Quantidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map((product) => (
                                <tr key={product.CODIGO}>
                                    <td>{product.CODIGO}</td>
                                    <td>{product.DESCRICAO}</td>
                                    <td>{product.QUANTIDADE_NOVA}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalProduct;
